// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"66022e60","453":"a6304e84"}[chunkId] + ".chunk.js";
};